import { api } from '../lib/api';

export interface SuperAdminUser {
  id: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  isActive: number;
  superAdminPromotedAt: string | null;
}

export interface SuperAdminOverviewRow {
  userId: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  isSuperAdmin: number;
  businessId: number | null;
  businessName: string | null;
  planCode: string | null;
  planStartAt: string | null;
  planEndAt: string | null;
  pendingPurchaseId: number | null;
  pendingTargetPlanCode: string | null;
  pendingAmountToPaySek: number | null;
  pendingCreatedAt: string | null;
}

export const superAdminApi = {
  listSuperAdmins: () => api.get<{ superAdmins: SuperAdminUser[] }>('/superadmin/list'),
  overview: () => api.get<{ rows: SuperAdminOverviewRow[] }>('/superadmin/overview'),
  promote: (userId: number) => api.post<{ ok: boolean }>('/superadmin/promote', { userId }),
  demote: (userId: number) => api.post<{ ok: boolean }>('/superadmin/demote', { userId }),
  approvePendingPurchase: (purchaseId: number) =>
    api.post<{ ok: boolean }>('/superadmin/purchases/approve', { purchaseId }),
};

